/**
 * Authentication Validators
 * Validates authentication-related inputs: passwords, password matching
 */

/**
 * Validates password strength
 * @param {string} password - Password to validate
 * @param {number} minLength - Minimum length (default: 6)
 * @returns {object} { valid: boolean, error: string|null }
 */
export function validatePassword(password, minLength = 6) {
  if (!password || typeof password !== 'string') {
    return { valid: false, error: 'Password is required' }
  }
  
  if (password.length < minLength) {
    return { valid: false, error: `Password must be at least ${minLength} characters` }
  }
  
  return { valid: true, error: null }
}

/**
 * Validates that two passwords match
 * @param {string} password - Password
 * @param {string} confirmPassword - Confirmation password
 * @returns {object} { valid: boolean, error: string|null }
 */
export function validatePasswordMatch(password, confirmPassword) {
  if (!confirmPassword) {
    return { valid: false, error: 'Please confirm your password' }
  }
  
  if (password !== confirmPassword) {
    return { valid: false, error: 'Passwords do not match' }
  }
  
  return { valid: true, error: null }
}
